import { Colors } from "../constants/colors";

export default {
  variants: [
    {
      props: { variant: "filled" },
      style: {
        fontFamily: "ey_interstate",
        fontSize: "10px",
        fontWeight: 300,
      },
    },
    {
      props: { variant: "clear" },
      style: {
        fontFamily: "ey_interstate",
        fontSize: "13px",
        fontWeight: 300,
        borderColor: "transparent",
        backgroundColor: "transparent",
        color: "#2E2E38",
      },
    },
    {
      props: { variant: "filterChip" },
      style: {
        border: `1px solid ${Colors.GRAY300}`,
        borderRadius: 2,
        backgroundColor: Colors.GREY100,
        margin: 5,
        "&:first-of-type": {
          marginLeft: 0
        },
        "& .MuiChip-label": {
          padding: "1px 2px",
          lineHeight: "12px",
          "& .label": {
            paddingLeft: 7,
            paddingRight: 7,
            lineHeight: "12px",
          },
          "& .value": {
            padding: "2px 5px",
            backgroundColor: Colors.WHITE,
            border: `1px solid ${Colors.GRAY300}`,
            lineHeight: "12px",
          },
        },
      },
    },
    {
      props: { variant: "primary" },
      style: {
        margin: 5,
        padding: "15px 8px",
        fontSize: 14,
        fontWeight: 400,
        backgroundColor: Colors.GREY250,
        color: Colors.GREY400,
      },
    },
    {
      props: { variant: "popoverFilterChip" },
      style: {
        border: `1px solid ${Colors.GRAY300}`,
        borderRadius: 2,
        backgroundColor: Colors.GREY100,
        "& .MuiChip-label": {
          paddingLeft: 7,
          width: 150
        },
        "& .MuiChip-deleteIcon": {
          color: Colors.GREY350,
          fontSize: 14
        }
      },
    },
  ],
};
